window.addEventListener('load', function() {
    var rightDiv = document.querySelector('.side-by-side-container .right');
// var height = rightDiv.clientheight;
    console.log("🎃🎃🎃🎃🎃🎃🎃🎃");
    console.log(rightDiv);
    console.log(rightDiv.offsetHeight);
});

